import React from 'react';

import { UbiNavigationFactory } from 'utils/ubi/types';

const dummyUbi = {
  logArticleImpression: () => undefined,
  logArticleLink: () => undefined,
  logVideoImpression: () => undefined,
  logAccordionImpression: () => undefined,
  logAccordionInteraction: () => undefined,
  logLinkImpression: () => undefined,
  logLinkInteraction: () => undefined,
  logArticleHelpfulImpression: () => undefined,
  logArticleHelpfulYes: () => undefined,
  logArticleHelpfulNo: () => undefined,
} as any as BlockSerializerUbi;

export interface BlockSerializerUbi {
  logArticleImpression: () => void;
  logArticleLink: (slug: string) => UbiNavigationFactory | undefined;
  logVideoImpression: (vimeoId: string) => void;
  logAccordionImpression: (key: string) => void;
  logAccordionInteraction: (key: string, expanded: boolean) => void;
  logLinkImpression: (uri: string) => void;
  logLinkInteraction: (uri: string) => void;
  logArticleHelpfulImpression?: () => void;
  logArticleHelpfulYes?: () => void;
  logArticleHelpfulNo?: () => void;
}

export const BlockSerializerUbiContext = React.createContext<BlockSerializerUbi>(dummyUbi);
